import IndianTraditionalProducts from "./IndianTraditionalProducts";

export default IndianTraditionalProducts;